import Expenses from "./components/expenses/Expenses";
import React,{useState} from 'react';
import NewExpense from './components/NewExpense/NewExpense'
const initExpenses = [
  {
    id: "e1",
    title: "Disinfectants ",
    amount: 94.12,
    date: new Date(2020, 7, 14),
  },
  { id: "e2", title: "New TV", amount: 799.49, date: new Date(2021, 2, 12) },
  {
    id: "e3",
    title: "Car Insurance",
    amount: 294.67,
    date: new Date(2021, 2, 28),
  },
  {
    id: "e4",
    title: "New Desk (Wooden)",
    amount: 450,
    date: new Date(2021, 5, 12),
  }
 ];
function App() {

 const [expenses,setExpenses]=useState(initExpenses);
  const newExpenseHandler = (expense)=>{
    setExpenses((prevExpense)=>{
      return [expense,...prevExpense];
    })
  }
  // return React.createElement('div',{},
  // React.createElement('h2',{},'Let\'s get started!'),
  // React.createElement(Expenses,{expenses:expenses})
  // );
  return (
    <div>
      <NewExpense onSaveExpenseData = {newExpenseHandler}/>
      <Expenses expenses={expenses}/>
    </div>
  );
}

export default App;
